/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/UpdateCartDelivery.ts"
/*!*****************************************!*\
  !*** ./resources/UpdateCartDelivery.ts ***!
  \*****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartDelivery)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CartDelivery = /*#__PURE__*/function (_HTMLElement) {
  function CartDelivery() {
    var _this;
    _classCallCheck(this, CartDelivery);
    _this = _callSuper(this, CartDelivery);
    _defineProperty(_this, "observer", void 0);
    _defineProperty(_this, "countdownTimer", void 0);
    _this.updateCartDeliveryText = _this.updateCartDeliveryText.bind(_this);
    _this.handleEvent = _this.handleEvent.bind(_this);
    _this.handleCartContentLoaded = _this.handleCartContentLoaded.bind(_this);
    _this.init = _this.init.bind(_this);
    _this.updateLiveTimeCountdown = _this.updateLiveTimeCountdown.bind(_this);
    _this.startCountdown = _this.startCountdown.bind(_this);
    return _this;
  }
  // eslint-disable-next-line class-methods-use-this
  _inherits(CartDelivery, _HTMLElement);
  return _createClass(CartDelivery, [{
    key: "getDeliveryConfig",
    value: function getDeliveryConfig() {
      var windowAny = window;
      // Detect current market (you can customize this logic based on your market detection)
      var currentMarket = windowAny.currentMarket || "default";
      var config = {
        mondayMin: windowAny.deliveryMondayMin || 1,
        mondayMax: windowAny.deliveryMondayMax || 3,
        tuesdayMin: windowAny.deliveryTuesdayMin || 1,
        tuesdayMax: windowAny.deliveryTuesdayMax || 3,
        wednesdayMin: windowAny.deliveryWednesdayMin || 1,
        wednesdayMax: windowAny.deliveryWednesdayMax || 3,
        thursdayMin: windowAny.deliveryThursdayMin || 1,
        thursdayMax: windowAny.deliveryThursdayMax || 4,
        fridayMin: windowAny.deliveryFridayMin || 3,
        fridayMax: windowAny.deliveryFridayMax || 5,
        saturdayMin: windowAny.deliverySaturdayMin || 3,
        saturdayMax: windowAny.deliverySaturdayMax || 5,
        sundayMin: windowAny.deliverySundayMin || 2,
        sundayMax: windowAny.deliverySundayMax || 4
      };
      // Check for market-specific configuration
      if (currentMarket !== "default") {
        var market1Id = windowAny.market1Identifier;
        var market2Id = windowAny.market2Identifier;
        var market3Id = windowAny.market3Identifier;
        if (market1Id && currentMarket === market1Id) {
          config = {
            mondayMin: windowAny.market1MondayMin || config.mondayMin,
            mondayMax: windowAny.market1MondayMax || config.mondayMax,
            tuesdayMin: windowAny.market1TuesdayMin || config.tuesdayMin,
            tuesdayMax: windowAny.market1TuesdayMax || config.tuesdayMax,
            wednesdayMin: windowAny.market1WednesdayMin || config.wednesdayMin,
            wednesdayMax: windowAny.market1WednesdayMax || config.wednesdayMax,
            thursdayMin: windowAny.market1ThursdayMin || config.thursdayMin,
            thursdayMax: windowAny.market1ThursdayMax || config.thursdayMax,
            fridayMin: windowAny.market1FridayMin || config.fridayMin,
            fridayMax: windowAny.market1FridayMax || config.fridayMax,
            saturdayMin: windowAny.market1SaturdayMin || config.saturdayMin,
            saturdayMax: windowAny.market1SaturdayMax || config.saturdayMax,
            sundayMin: windowAny.market1SundayMin || config.sundayMin,
            sundayMax: windowAny.market1SundayMax || config.sundayMax
          };
        } else if (market2Id && currentMarket === market2Id) {
          config = {
            mondayMin: windowAny.market2MondayMin || config.mondayMin,
            mondayMax: windowAny.market2MondayMax || config.mondayMax,
            tuesdayMin: windowAny.market2TuesdayMin || config.tuesdayMin,
            tuesdayMax: windowAny.market2TuesdayMax || config.tuesdayMax,
            wednesdayMin: windowAny.market2WednesdayMin || config.wednesdayMin,
            wednesdayMax: windowAny.market2WednesdayMax || config.wednesdayMax,
            thursdayMin: windowAny.market2ThursdayMin || config.thursdayMin,
            thursdayMax: windowAny.market2ThursdayMax || config.thursdayMax,
            fridayMin: windowAny.market2FridayMin || config.fridayMin,
            fridayMax: windowAny.market2FridayMax || config.fridayMax,
            saturdayMin: windowAny.market2SaturdayMin || config.saturdayMin,
            saturdayMax: windowAny.market2SaturdayMax || config.saturdayMax,
            sundayMin: windowAny.market2SundayMin || config.sundayMin,
            sundayMax: windowAny.market2SundayMax || config.sundayMax
          };
        } else if (market3Id && currentMarket === market3Id) {
          config = {
            mondayMin: windowAny.market3MondayMin || config.mondayMin,
            mondayMax: windowAny.market3MondayMax || config.mondayMax,
            tuesdayMin: windowAny.market3TuesdayMin || config.tuesdayMin,
            tuesdayMax: windowAny.market3TuesdayMax || config.tuesdayMax,
            wednesdayMin: windowAny.market3WednesdayMin || config.wednesdayMin,
            wednesdayMax: windowAny.market3WednesdayMax || config.wednesdayMax,
            thursdayMin: windowAny.market3ThursdayMin || config.thursdayMin,
            thursdayMax: windowAny.market3ThursdayMax || config.thursdayMax,
            fridayMin: windowAny.market3FridayMin || config.fridayMin,
            fridayMax: windowAny.market3FridayMax || config.fridayMax,
            saturdayMin: windowAny.market3SaturdayMin || config.saturdayMin,
            saturdayMax: windowAny.market3SaturdayMax || config.saturdayMax,
            sundayMin: windowAny.market3SundayMin || config.sundayMin,
            sundayMax: windowAny.market3SundayMax || config.sundayMax
          };
        }
      }
      return config;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getExpectedDeliveryDates",
    value: function getExpectedDeliveryDates() {
      var today = new Date();
      var dayOfWeek = today.getDay();
      var config = this.getDeliveryConfig();
      var minDays;
      var maxDays;
      switch (dayOfWeek) {
        case 1:
          // Monday
          minDays = config.mondayMin;
          maxDays = config.mondayMax;
          break;
        case 2:
          // Tuesday
          minDays = config.tuesdayMin;
          maxDays = config.tuesdayMax;
          break;
        case 3:
          // Wednesday
          minDays = config.wednesdayMin;
          maxDays = config.wednesdayMax;
          break;
        case 4:
          // Thursday
          minDays = config.thursdayMin;
          maxDays = config.thursdayMax;
          break;
        case 5:
          // Friday
          minDays = config.fridayMin;
          maxDays = config.fridayMax;
          break;
        case 6:
          // Saturday
          minDays = config.saturdayMin;
          maxDays = config.saturdayMax;
          break;
        case 0:
          // Sunday
          minDays = config.sundayMin;
          maxDays = config.sundayMax;
          break;
        default:
          throw new Error("Invalid day of the week");
      }
      var minDeliveryDate = new Date(today.getTime() + minDays * 24 * 60 * 60 * 1000);
      var maxDeliveryDate = new Date(today.getTime() + maxDays * 24 * 60 * 60 * 1000);
      var storeLangSetting = window.storeLang || "da";
      var options = {
        day: "numeric",
        month: "long"
      };
      var minDateStr = minDeliveryDate.toLocaleDateString(storeLangSetting, options);
      var maxDateStr = maxDeliveryDate.toLocaleDateString(storeLangSetting, options);
      // If min and max are the same date, show only one date
      if (minDateStr === maxDateStr) {
        return minDateStr;
      }
      return "".concat(minDateStr, "\u2013").concat(maxDateStr);
    }
  }, {
    key: "updateCartDeliveryText",
    value: function updateCartDeliveryText() {
      var _this2 = this;
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      cartdeliveryTextElements.forEach(function (element) {
        element.innerText = "".concat(_this2.getExpectedDeliveryDates());
      });
    }
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      // hide live time on weekends
      var day = new Date().getDay();
      // 0 = Sunday, 6 = Saturday
      if (day === 0 || day === 6) {
        var liveTimeContainer = document.querySelector(".liveTimeContainer");
        if (liveTimeContainer) liveTimeContainer.style.display = "none";
        return;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.updateLiveTimeCountdown();
      this.countdownTimer = window.setInterval(this.updateLiveTimeCountdown, 1000);
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLiveTimeCountdown",
    value: function updateLiveTimeCountdown() {
      var liveTimeElement = document.querySelector(".liveTime");
      var liveTimeContainer = document.querySelector(".liveTimeContainer");
      if (!liveTimeElement) return;
      var now = new Date();
      // customized to show countdown until 12:00 instead of 15:00 variables are threePm still used for the logic
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      var threePm = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
      // If it's before midnight or at/after 12:00 => hide the timer
      if (now < midnight || now >= threePm) {
        liveTimeContainer.style.display = "none";
        return;
      }
      liveTimeContainer.style.display = "block";
      var distance = threePm.getTime() - now.getTime();
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      var hh = hours.toString().padStart(2, "0");
      var mm = minutes.toString().padStart(2, "0");
      var ss = seconds.toString().padStart(2, "0");
      liveTimeElement.innerText = "".concat(hh, ":").concat(mm, ":").concat(ss);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.observer = new MutationObserver(function () {
        var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
        if (cartdeliveryTextElements.length > 0) {
          _this3.updateCartDeliveryText();
          _this3.observer.disconnect();
        }
      });
      this.init();
      // Start the countdown to 15:00 (it will hide itself if outside 00:00–15:00)
      this.startCountdown();
    }
  }, {
    key: "init",
    value: function init() {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      /*
        If you want to handle certain Shopify (or custom) events, re-add them here.
        For example:
          document.addEventListener('line-item:change:start', this.handleEvent);
          document.addEventListener('line-item:change:end', this.handleEvent);
          document.addEventListener('cart:item-added', this.handleEvent);
          document.addEventListener('product:variant-change', this.handleEvent);
          document.addEventListener('DOMContentLoaded', this.handleEvent);
      */
      this.handleCartContentLoaded();
      this.interceptNetRequest();
    }
  }, {
    key: "interceptNetRequest",
    value: function interceptNetRequest() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (typeof url === "string" && (url.includes("cart/add") || url.includes("cart/change"))) {
                  this.handleEvent();
                }
                return _context.a(2, originalFetch(url, options));
            }
          }, _callee, this);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      } else {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: "handleCartContentLoaded",
    value: function handleCartContentLoaded() {
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      document.removeEventListener("DOMContentLoaded", this.handleCartContentLoaded);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/app.ts"
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/CookieBanner/Cookiebanner */ "./resources/scripts/components/CookieBanner/Cookiebanner.ts");
/* harmony import */ var _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_SizeModal_SizeModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/SizeModal/SizeModal */ "./resources/scripts/components/SizeModal/SizeModal.ts");
/* harmony import */ var _UpdateCartDelivery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./UpdateCartDelivery */ "./resources/UpdateCartDelivery.ts");
/* harmony import */ var _scripts_components_VariantSelection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/VariantSelection */ "./resources/scripts/components/VariantSelection/VariantSelection.ts");





customElements.define("cart-delivery", _UpdateCartDelivery__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define("cookie-banner", _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define("geolocator-component", _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define("variant-selection", _scripts_components_VariantSelection__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define("size-modal", _scripts_components_SizeModal_SizeModal__WEBPACK_IMPORTED_MODULE_2__["default"]);

/***/ },

/***/ "./resources/scripts/components/CookieBanner/Cookiebanner.ts"
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/Cookiebanner.ts ***!
  \*******************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner);
    _defineProperty(_this, "panelConsent", null);
    _defineProperty(_this, "panelDetails", null);
    _defineProperty(_this, "tabConsent", null);
    _defineProperty(_this, "tabDetails", null);
    _defineProperty(_this, "consentApiReady", false);
    _this.showConsentTab = _this.showConsentTab.bind(_this);
    _this.showDetailsTab = _this.showDetailsTab.bind(_this);
    _this.initSyncedCheckboxes = _this.initSyncedCheckboxes.bind(_this);
    _this.initConsentApis = _this.initConsentApis.bind(_this);
    _this.bindActionButtons = _this.bindActionButtons.bind(_this);
    _this.handleAllowAll = _this.handleAllowAll.bind(_this);
    _this.handleAllowSelected = _this.handleAllowSelected.bind(_this);
    _this.handleReject = _this.handleReject.bind(_this);
    _this.applyConsent = _this.applyConsent.bind(_this);
    _this.getSelections = _this.getSelections.bind(_this);
    _this.showBanner = _this.showBanner.bind(_this);
    _this.hideBanner = _this.hideBanner.bind(_this);
    _this.ensureGtag = _this.ensureGtag.bind(_this);
    _this.getOverlay = _this.getOverlay.bind(_this);
    _this.restoreSelections = _this.restoreSelections.bind(_this);
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var recall, showBanner;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tabConsent = this.querySelector("#tab-consent");
              this.tabDetails = this.querySelector("#tab-details");
              this.panelConsent = this.querySelector("#panel-consent");
              this.panelDetails = this.querySelector("#panel-details");
              if (this.tabConsent) this.tabConsent.addEventListener("click", this.showConsentTab);
              if (this.tabDetails) this.tabDetails.addEventListener("click", this.showDetailsTab);
              _context.n = 1;
              return this.initConsentApis();
            case 1:
              this.showConsentTab();
              this.initSyncedCheckboxes();
              this.seedSelectionsFromHtmlIfFirstVisit();
              _context.n = 2;
              return this.restoreSelections();
            case 2:
              this.bindActionButtons();
              recall = document.getElementById("recall-consent-banner");
              if (recall) {
                recall.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.showBanner();
                });
              }
              _context.n = 3;
              return this.checkConsentBannerInteraction();
            case 3:
              showBanner = _context.v;
              if (showBanner) this.showBanner();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }() // Show banner if visitor hasn't made a choice yet
  }, {
    key: "checkConsentBannerInteraction",
    value: function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window$Shopify;
        var _visitorConsent$prefe, _visitorConsent$analy, _visitorConsent$marke, visitorConsent, empty, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(localStorage.getItem("consentGiven") === "true")) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, false);
            case 1:
              if (!(!this.consentApiReady || !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent))) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, true);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 3:
              visitorConsent = _context2.v;
              empty = ((_visitorConsent$prefe = visitorConsent.preferences) !== null && _visitorConsent$prefe !== void 0 ? _visitorConsent$prefe : "") === "" && ((_visitorConsent$analy = visitorConsent.analytics) !== null && _visitorConsent$analy !== void 0 ? _visitorConsent$analy : "") === "" && ((_visitorConsent$marke = visitorConsent.marketing) !== null && _visitorConsent$marke !== void 0 ? _visitorConsent$marke : "") === "";
              return _context2.a(2, empty);
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              return _context2.a(2, true);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
  }, {
    key: "showConsentTab",
    value: function showConsentTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.remove("tw:hidden!");
        this.panelConsent.classList.add("active");
        this.panelDetails.classList.add("tw:hidden!");
        this.panelDetails.classList.remove("active");
        this.tabConsent.classList.add("active");
        this.tabDetails.classList.remove("active");
      }
    }
  }, {
    key: "showDetailsTab",
    value: function showDetailsTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.add("tw:hidden!");
        this.panelConsent.classList.remove("active");
        this.panelDetails.classList.remove("tw:hidden!");
        this.panelDetails.classList.add("active");
        this.tabConsent.classList.remove("active");
        this.tabDetails.classList.add("active");
      }
    }
  }, {
    key: "initSyncedCheckboxes",
    value: function initSyncedCheckboxes() {
      var all = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
      var onChange = function onChange(event) {
        var target = event.currentTarget;
        var key = target.dataset.consent;
        if (!key) return;
        var checked = target.checked;
        all.forEach(function (other) {
          if (other === target) return;
          if (other.dataset.consent !== key) return;
          if (!other.disabled) other.checked = checked;
        });
      };
      all.forEach(function (checkbox) {
        return checkbox.addEventListener("change", onChange);
      });
      var byKey = new Map();
      all.forEach(function (checkbox) {
        var key = checkbox.dataset.consent;
        if (!byKey.has(key)) byKey.set(key, []);
        byKey.get(key).push(checkbox);
      });
      Array.from(byKey.values()).forEach(function (group) {
        var source = group[0];
        group.slice(1).forEach(function (checkbox) {
          if (!checkbox.disabled) checkbox.checked = source.checked;
        });
      });
    }
  }, {
    key: "initConsentApis",
    value: function () {
      var _initConsentApis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _window$gtag,
          _window,
          _window$gtag2,
          _window2,
          _window$gtag3,
          _window3,
          _window$Shopify2,
          _this3 = this;
        var localStorageCookieSelections, selections, defaultConsent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.ensureGtag();
              localStorageCookieSelections = localStorage.getItem("cookieSelections");
              selections = localStorageCookieSelections ? function () {
                try {
                  return JSON.parse(localStorageCookieSelections);
                } catch (_unused2) {
                  return {
                    personalization: false,
                    marketing: false,
                    analytics: false
                  };
                }
              }() : {
                personalization: false,
                marketing: false,
                analytics: false
              };
              defaultConsent = {
                functionality_storage: "granted",
                analytics_storage: selections.analytics ? "granted" : "denied",
                personalization_storage: selections.personalization ? "granted" : "denied",
                ad_personalization: selections.personalization ? "granted" : "denied",
                ad_storage: selections.marketing ? "granted" : "denied",
                ad_user_data: selections.marketing ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 || _window$gtag.call(_window, "consent", "default", defaultConsent);
              (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, "set", "ads_data_redaction", false);
              (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, "set", "url_passthrough", true);
              if ((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.loadFeatures) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return new Promise(function (resolve) {
                try {
                  window.Shopify.loadFeatures([{
                    name: "consent-tracking-api",
                    version: "0.1"
                  }], function (error) {
                    if (error) {
                      console.error("Error loading Shopify consent-tracking-api:", error);
                      resolve();
                      return;
                    }
                    _this3.consentApiReady = true;
                    resolve();
                    document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                      var _window$Shopify3, _window$Shopify3$curr, v, _t2;
                      return _regenerator().w(function (_context3) {
                        while (1) switch (_context3.p = _context3.n) {
                          case 0:
                            _context3.p = 0;
                            _context3.n = 1;
                            return (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.customerPrivacy) === null || _window$Shopify3 === void 0 || (_window$Shopify3$curr = _window$Shopify3.currentVisitorConsent) === null || _window$Shopify3$curr === void 0 ? void 0 : _window$Shopify3$curr.call(_window$Shopify3);
                          case 1:
                            v = _context3.v;
                            if (v) {
                              _context3.n = 2;
                              break;
                            }
                            return _context3.a(2);
                          case 2:
                            _this3.setGroup("personalization", v.preferences === "yes");
                            _this3.setGroup("marketing", v.marketing === "yes");
                            _this3.setGroup("analytics", v.analytics === "yes");
                            _this3.saveSelections();
                            _context3.n = 4;
                            break;
                          case 3:
                            _context3.p = 3;
                            _t2 = _context3.v;
                            console.error("visitorConsentCollected handler error:", _t2);
                          case 4:
                            return _context3.a(2);
                        }
                      }, _callee3, null, [[0, 3]]);
                    })));
                  });
                } catch (e) {
                  console.error("loadFeatures threw:", e);
                  resolve();
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initConsentApis() {
        return _initConsentApis.apply(this, arguments);
      }
      return initConsentApis;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ensureGtag",
    value: function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtagShim() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          window.dataLayer.push(args);
        };
      }
    }
  }, {
    key: "bindActionButtons",
    value: function bindActionButtons() {
      var allowAllBtn = this.querySelector(".allow-all-btn");
      var allowSelectedBtn = this.querySelector(".allow-selected-btn");
      var rejectBtn = this.querySelector('[data-action="reject"]');
      if (allowAllBtn) allowAllBtn.addEventListener("click", this.handleAllowAll);
      if (allowSelectedBtn) allowSelectedBtn.addEventListener("click", this.handleAllowSelected);
      if (rejectBtn) rejectBtn.addEventListener("click", this.handleReject);
    }
  }, {
    key: "handleAllowAll",
    value: function handleAllowAll() {
      var shopify = {
        preferences: "yes",
        marketing: "yes",
        analytics: "yes"
      };
      var allCheckboxes = this.querySelectorAll("input.ed-checkbox[data-consent]");
      allCheckboxes.forEach(function (checkbox) {
        if (!checkbox.disabled) checkbox.checked = true;
      });
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleAllowSelected",
    value: function handleAllowSelected() {
      var _this$getSelections = this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      var shopify = {
        preferences: personalization ? "yes" : "no",
        marketing: marketing ? "yes" : "no",
        analytics: analytics ? "yes" : "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleReject",
    value: function handleReject() {
      var shopify = {
        preferences: "no",
        marketing: "no",
        analytics: "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "seedSelectionsFromHtmlIfFirstVisit",
    value: function seedSelectionsFromHtmlIfFirstVisit() {
      var _this$querySelector, _this$querySelector2, _this$querySelector3;
      if (localStorage.getItem("cookieSelections")) return;
      var selections = {
        personalization: !!((_this$querySelector = this.querySelector('input.ed-checkbox[data-consent="personalization"]')) !== null && _this$querySelector !== void 0 && _this$querySelector.checked),
        marketing: !!((_this$querySelector2 = this.querySelector('input.ed-checkbox[data-consent="marketing"]')) !== null && _this$querySelector2 !== void 0 && _this$querySelector2.checked),
        analytics: !!((_this$querySelector3 = this.querySelector('input.ed-checkbox[data-consent="analytics"]')) !== null && _this$querySelector3 !== void 0 && _this$querySelector3.checked)
      };
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "setGroup",
    value: function setGroup(key, checked) {
      var boxes = this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]"));
      boxes.forEach(function (cb) {
        if (!cb.disabled) cb.checked = checked;
      });
    }
  }, {
    key: "restoreSelections",
    value: function () {
      var _restoreSelections = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var raw, selections;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              raw = localStorage.getItem("cookieSelections");
              if (raw) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              try {
                selections = JSON.parse(raw);
                this.setGroup("personalization", selections.personalization);
                this.setGroup("marketing", selections.marketing);
                this.setGroup("analytics", selections.analytics);
              } catch (event) {
                console.warn("Invalid cookieSelections in localStorage; leaving HTML defaults.", event);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function restoreSelections() {
        return _restoreSelections.apply(this, arguments);
      }
      return restoreSelections;
    }()
  }, {
    key: "saveSelections",
    value: function saveSelections() {
      var selections = this.getSelections();
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var _this4 = this;
      var isConsentChecked = function isConsentChecked(consentType) {
        var _this4$querySelector;
        return !!((_this4$querySelector = _this4.querySelector("input.ed-checkbox[data-consent=\"".concat(consentType, "\"]"))) !== null && _this4$querySelector !== void 0 && _this4$querySelector.checked);
      };
      return {
        personalization: isConsentChecked("personalization"),
        marketing: isConsentChecked("marketing"),
        analytics: isConsentChecked("analytics")
      };
    }
  }, {
    key: "applyConsent",
    value: function () {
      var _applyConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shopify, hide) {
        var _window$gtag4, _window4, _window$Shopify4, _window$Shopify4$setT;
        var google;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              google = {
                functionality_storage: "granted",
                analytics_storage: shopify.analytics === "yes" ? "granted" : "denied",
                personalization_storage: shopify.preferences === "yes" ? "granted" : "denied",
                ad_personalization: shopify.preferences === "yes" ? "granted" : "denied",
                ad_storage: shopify.marketing === "yes" ? "granted" : "denied",
                ad_user_data: shopify.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag4 = (_window4 = window).gtag) === null || _window$gtag4 === void 0 || _window$gtag4.call(_window4, "consent", "update", google);
              this.saveSelections();
              localStorage.setItem("consentGiven", "true");
              (_window$Shopify4 = window.Shopify) === null || _window$Shopify4 === void 0 || (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null || _window$Shopify4 === void 0 || (_window$Shopify4$setT = _window$Shopify4.setTrackingConsent) === null || _window$Shopify4$setT === void 0 || _window$Shopify4$setT.call(_window$Shopify4, {
                analytics: shopify.analytics === "yes",
                marketing: shopify.marketing === "yes",
                preferences: shopify.preferences === "yes"
              });
              if (hide) this.hideBanner();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function applyConsent(_x, _x2) {
        return _applyConsent.apply(this, arguments);
      }
      return applyConsent;
    }()
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      return this.querySelector("[data-cookie-overlay]") || this;
    }
  }, {
    key: "showBanner",
    value: function showBanner() {
      var element = this.getOverlay();
      element.removeAttribute("hidden");
      element.classList.remove("tw:hidden!");
    }
  }, {
    key: "hideBanner",
    value: function hideBanner() {
      var element = this.getOverlay();
      element.classList.add("tw:hidden!");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts"
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "geolocatorScript", void 0);
    _defineProperty(_this, "countryDataArray", void 0);
    _defineProperty(_this, "geolocatorContentTemplate", void 0);
    _defineProperty(_this, "geolocatorContentPlaceholder", void 0);
    _defineProperty(_this, "modal", void 0);
    _defineProperty(_this, "closeModalButton", void 0);
    _defineProperty(_this, "closeCountryListModalButton", void 0);
    _defineProperty(_this, "countryModalToggle", void 0);
    _defineProperty(_this, "countryListModal", void 0);
    _defineProperty(_this, "countryListModalToggles", void 0);
    _defineProperty(_this, "countryListButtons", void 0);
    _defineProperty(_this, "stayButton", void 0);
    _defineProperty(_this, "leaveButton", void 0);
    _defineProperty(_this, "overlay", void 0);
    _this.getBrowsingContext = _this.getBrowsingContext.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var isCookied, browsingContext, activeCountry, recommendedMatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.initDataAndElements();
              this.addEventListeners();
              this.handleGeolocationCookie();
              isCookied = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)("geolocation");
              if (!isCookied) {
                _context.n = 1;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Geolocation cookie is set. Geolocator will not run.");
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.getBrowsingContext();
            case 2:
              browsingContext = _context.v;
              activeCountry = this.getActiveCountryAndLanguage();
              recommendedMatch = this.getRecommendedMatch(browsingContext); // If the recommended match is the same as the active country, return early as we do not need to show the geolocator
              if (!((recommendedMatch === null || recommendedMatch === void 0 ? void 0 : recommendedMatch.handle) === activeCountry.country)) {
                _context.n = 3;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Recommended match is the same as the active country. Geolocator will not run.");
              return _context.a(2);
            case 3:
              this.toggleGeolocator();
              this.setupGeolocatorContent(recommendedMatch);
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "handleGeolocationCookie",
    value: function handleGeolocationCookie() {
      var urlParams = new URLSearchParams(window.location.search);
      var geolocation = urlParams.get("geolocation");
      if (geolocation) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", geolocation, 30);
      }
    }
  }, {
    key: "toggleGeolocator",
    value: function toggleGeolocator() {
      var _this2 = this;
      this.classList.toggle("tw:hidden");
      this.setAttribute("geolocation-modal-active", this.getAttribute("geolocation-modal-active") === "true" ? "false" : "true");
      setTimeout(function () {
        _this2.modal.classList.toggle("active");
      }, 300);
    }
  }, {
    key: "setupGeolocatorContent",
    value: function setupGeolocatorContent(recommendedMatch) {
      var _this3 = this;
      var geolocatorContent = this.geolocatorContentTemplate.content.cloneNode(true);
      var content = geolocatorContent.querySelector("[data-id=\"".concat(recommendedMatch.id, "\"]"));
      if (content) {
        this.geolocatorContentPlaceholder.appendChild(content);
      }
      this.countryModalToggle = this.querySelector(".country-modal-toggle");
      this.stayButton = this.querySelector(".stay-button");
      this.leaveButton = this.querySelector(".leave-button");
      this.countryModalToggle.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.toggleCountryListModal(_this3.countryModalToggle);
      });
      this.stayButton.addEventListener("click", function (event) {
        event.preventDefault();
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", recommendedMatch.handle, 30);
        _this3.toggleGeolocator();
      });
      this.leaveButton.addEventListener("click", function (event) {
        event.preventDefault();
        var _this3$leaveButton$da = _this3.leaveButton.dataset,
          locale = _this3$leaveButton$da.locale,
          handle = _this3$leaveButton$da.handle,
          type = _this3$leaveButton$da.type,
          url = _this3$leaveButton$da.url;
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", handle, 30);
        var isMarket = type === "market";
        if (!isMarket) {
          // For country type, use the external URL if provided
          if (url) {
            window.location.href = url;
          } else {
            window.location.href = "".concat(window.location.href, "?geolocation=").concat(handle);
          }
          return;
        }
        _this3.handleMarketSwitch(handle, locale);
      });
    }
  }, {
    key: "toggleCountryListModal",
    value: function toggleCountryListModal(trigger) {
      var geoLocatorActive = this.getAttribute("geolocation-modal-active") === "true";
      // make it boolean
      var isInModalTrigger = trigger.dataset.inmodaltoggle === "true";
      if (isInModalTrigger && !geoLocatorActive) {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.toggle("active");
        return;
      }
      if (isInModalTrigger) {
        this.modal.classList.toggle("active");
        this.countryListModal.classList.toggle("active");
      } else {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.add("active");
      }
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.modal = this.querySelector("#geolocator-modal");
      this.closeModalButton = this.querySelector("#close-geolocator-modal");
      this.geolocatorScript = this.querySelector("#geolocator-script");
      this.countryDataArray = JSON.parse(this.geolocatorScript.innerHTML);
      this.geolocatorContentTemplate = this.querySelector("#geolocator-content-tempalte");
      this.geolocatorContentPlaceholder = this.querySelector("#geolocator-content-placeholder");
      this.countryListModal = this.querySelector("#geolocator-countrylist-modal");
      this.closeCountryListModalButton = this.querySelector("#close-geolocator-countrylist-modal");
      this.countryListButtons = Array.from(this.querySelectorAll(".countrylist-button"));
      this.countryListModalToggles = Array.from(document.querySelectorAll(".country-modal-toggle"));
      this.overlay = this.querySelector(".geolocator-overlay");
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$closeModalButto,
        _this4 = this;
      (_this$closeModalButto = this.closeModalButton) === null || _this$closeModalButto === void 0 || _this$closeModalButto.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleGeolocator();
      });
      this.closeCountryListModalButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleCountryListModal(_this4.closeCountryListModalButton);
      });
      this.countryListButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.handleCountryListButtonClick(button);
        });
      });
      this.countryListModalToggles.forEach(function (toggle) {
        toggle === null || toggle === void 0 || toggle.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.toggleCountryListModal(toggle);
        });
      });
    }
  }, {
    key: "handleCountryListButtonClick",
    value: function handleCountryListButtonClick(button) {
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", button.dataset.handle, 30);
      var isMarket = button.dataset.type === "market";
      if (!isMarket) {
        // For country type, use the external URL if provided
        var url = button.dataset.url;
        if (url) {
          window.location.href = url;
        } else {
          window.location.href = "".concat(window.location.href, "?geolocation=").concat(button.dataset.handle);
        }
        return;
      }
      var _button$dataset = button.dataset,
        locale = _button$dataset.locale,
        handle = _button$dataset.handle;
      this.handleMarketSwitch(handle, locale);
    }
  }, {
    key: "handleMarketSwitch",
    value: function handleMarketSwitch(handle, locale) {
      var formId = crypto.randomUUID();
      var formElement = document.createElement("form");
      formElement.id = formId;
      formElement.action = "/localization";
      formElement.method = "POST";
      formElement.hidden = true;
      formElement.innerHTML = "\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"".concat(handle, "\">\n      <input name=\"language_code\" value=\"").concat(locale, "\">\n      <input name=\"return_to\" value=\"").concat(window.location.href, "?geolocation=").concat(handle, "\">\n    ");
      document.body.appendChild(formElement);
      formElement.submit();
    }
  }, {
    key: "getActiveCountryAndLanguage",
    value: function getActiveCountryAndLanguage() {
      var _window$Shopify = window.Shopify,
        country = _window$Shopify.country,
        locale = _window$Shopify.locale;
      return {
        country: country,
        locale: locale
      };
    }
  }, {
    key: "getRecommendedMatch",
    value: function getRecommendedMatch(browsingContext) {
      if (!browsingContext) return; // If no browsing context, return early
      var suggestedCountry = browsingContext.suggestedCountry,
        suggestedLanguage = browsingContext.suggestedLanguage,
        detectedCountry = browsingContext.detectedCountry;
      var countryHandle = (suggestedCountry === null || suggestedCountry === void 0 ? void 0 : suggestedCountry.handle) || (detectedCountry === null || detectedCountry === void 0 ? void 0 : detectedCountry.handle);
      var languageHandle = suggestedLanguage === null || suggestedLanguage === void 0 ? void 0 : suggestedLanguage.handle;
      if (!countryHandle) return;
      // Helper function to parse countries string into array
      var parseCountries = function parseCountries(countriesStr) {
        if (!countriesStr) return [];
        return countriesStr.split(",").map(function (c) {
          return c.trim().toUpperCase();
        }).filter(function (c) {
          return c.length > 0;
        });
      };
      // Helper function to check if a country is in a market's country list
      var isCountryInMarket = function isCountryInMarket(market, country) {
        var countries = parseCountries(market.countries || "");
        // If no countries defined, check if handle matches (single-country market)
        if (countries.length === 0) {
          return market.handle.toUpperCase() === country.toUpperCase();
        }
        // Check if country is in the list
        return countries.includes(country.toUpperCase());
      };
      // Look for an exact match (country in market's country list & matching language)
      var recommendedMatch = this.countryDataArray.find(function (market) {
        return isCountryInMarket(market, countryHandle) && market.locale === languageHandle;
      });
      // If no exact match, look for a market that contains this country (any language)
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return isCountryInMarket(market, countryHandle);
        });
      }
      // If still no match, find the primary market
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return market.primary;
        });
      }
      // In the end we either have
      // 1. An exact match on country (in market's country list) and language
      // 2. A match on country only (in market's country list)
      // 3. A match on primary market
      // eslint-disable-next-line consistent-return
      return recommendedMatch;
    }
  }, {
    key: "getBrowsingContext",
    value: function () {
      var _getBrowsingContext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, detectedValues, _detectedValues$count, handle, name, suggestions, suggestedCountry, suggestedLanguage, suggestion, browsingContext;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch("/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true");
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              detectedValues = data.detected_values;
              _detectedValues$count = detectedValues.country, handle = _detectedValues$count.handle, name = _detectedValues$count.name;
              suggestions = data.suggestions;
              suggestedCountry = null;
              suggestedLanguage = null;
              if (suggestions.length) {
                // Check if there is a suggestion who has parts.country.handle which is equal to detectedValues.country.handle
                suggestion = suggestions.find(function (_suggestion) {
                  return _suggestion.parts.country.handle === detectedValues.country.handle;
                });
                suggestedCountry = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.country;
                suggestedLanguage = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.language;
              }
              browsingContext = {
                detectedCountry: {
                  handle: handle,
                  name: name
                },
                suggestedCountry: suggestedCountry,
                suggestedLanguage: suggestedLanguage
              };
              return _context2.a(2, browsingContext);
          }
        }, _callee2);
      }));
      function getBrowsingContext() {
        return _getBrowsingContext.apply(this, arguments);
      }
      return getBrowsingContext;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/SizeModal/SizeModal.ts"
/*!*************************************************************!*\
  !*** ./resources/scripts/components/SizeModal/SizeModal.ts ***!
  \*************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SizeModal)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SizeModal = /*#__PURE__*/function (_HTMLElement) {
  function SizeModal() {
    var _this;
    _classCallCheck(this, SizeModal);
    _this = _callSuper(this, SizeModal);
    _defineProperty(_this, "modalRoot", null);
    _defineProperty(_this, "overlay", null);
    _defineProperty(_this, "openButtons", null);
    _defineProperty(_this, "closeButtons", null);
    _defineProperty(_this, "isOpen", false);
    _defineProperty(_this, "handleKeyDown", function (e) {
      if (e.key === "Escape" && _this.isOpen) {
        _this.closeModal();
      }
    });
    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
    return _this;
  }
  _inherits(SizeModal, _HTMLElement);
  return _createClass(SizeModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$openButtons,
        _this2 = this;
      this.openButtons = this.querySelectorAll("[data-modal-open]");
      (_this$openButtons = this.openButtons) === null || _this$openButtons === void 0 || _this$openButtons.forEach(function (btn) {
        return btn.addEventListener("click", _this2.openModal);
      });
      this.modalRoot = this.querySelector("[data-modal-root]") || null;
      if (!this.modalRoot) {
        var modalId = this.getAttribute("data-modal-id");
        if (modalId) {
          this.modalRoot = document.getElementById(modalId) || null;
        }
      }
      if (this.modalRoot) {
        if (this.modalRoot.parentNode !== document.body) {
          document.body.appendChild(this.modalRoot);
        }
        this.overlay = this.modalRoot.querySelector("[data-modal-overlay]") || null;
        this.rebindCloseButtons();
      }
    }
  }, {
    key: "rebindCloseButtons",
    value: function rebindCloseButtons() {
      var _this$closeButtons,
        _this3 = this,
        _this$closeButtons2;
      if (!this.modalRoot) return;
      (_this$closeButtons = this.closeButtons) === null || _this$closeButtons === void 0 || _this$closeButtons.forEach(function (btn) {
        return btn.removeEventListener("click", _this3.closeModal);
      });
      if (this.overlay) this.overlay.removeEventListener("click", this.handleOverlayClick);
      this.overlay = this.modalRoot.querySelector("[data-modal-overlay]") || null;
      this.closeButtons = this.modalRoot.querySelectorAll("[data-modal-close]");
      (_this$closeButtons2 = this.closeButtons) === null || _this$closeButtons2 === void 0 || _this$closeButtons2.forEach(function (btn) {
        return btn.addEventListener("click", _this3.closeModal);
      });
      if (this.overlay) this.overlay.addEventListener("click", this.handleOverlayClick);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$openButtons2,
        _this4 = this,
        _this$closeButtons3;
      (_this$openButtons2 = this.openButtons) === null || _this$openButtons2 === void 0 || _this$openButtons2.forEach(function (btn) {
        return btn.removeEventListener("click", _this4.openModal);
      });
      (_this$closeButtons3 = this.closeButtons) === null || _this$closeButtons3 === void 0 || _this$closeButtons3.forEach(function (btn) {
        return btn.removeEventListener("click", _this4.closeModal);
      });
      if (this.overlay) this.overlay.removeEventListener("click", this.handleOverlayClick);
      document.removeEventListener("keydown", this.handleKeyDown);
      // Clean up any patches we made to underlying modals
      this.restoreUnderlyingModals();
    }
  }, {
    key: "getModalRoot",
    value: function getModalRoot() {
      if (this.modalRoot && document.body.contains(this.modalRoot)) {
        return this.modalRoot;
      }
      var modalId = this.getAttribute("data-modal-id");
      if (modalId) {
        this.modalRoot = document.getElementById(modalId) || null;
      }
      return this.modalRoot;
    }
  }, {
    key: "handleOverlayClick",
    value: function handleOverlayClick(e) {
      if (e.target === this.overlay) {
        this.closeModal();
      }
    }
  }, {
    key: "openModal",
    value: function openModal(e) {
      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
        e.stopPropagation();
      }
      var modalRoot = this.getModalRoot();
      if (!modalRoot) return;
      this.rebindCloseButtons();
      // Patch underlying modals to allow clicks on the size guide
      this.patchUnderlyingModals();
      document.addEventListener("keydown", this.handleKeyDown);
      modalRoot.classList.remove("tw:hidden!");
      modalRoot.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("tw:overflow-hidden");
      this.isOpen = true;
    }
  }, {
    key: "patchUnderlyingModals",
    value: function patchUnderlyingModals() {
      var modalRoot = this.getModalRoot();
      if (!modalRoot) return;
      // Find all open modals/drawers that might be underneath
      var underlyingModals = document.querySelectorAll("x-modal[open], x-drawer[open], cart-drawer[open], quick-buy-modal[open]");
      underlyingModals.forEach(function (modal) {
        var modalEl = modal;
        // Store original methods if not already stored
        if (!modalEl._sizeGuideOriginalAllowOutsideClick) {
          modalEl._sizeGuideOriginalAllowOutsideClick = modalEl.allowOutsideClickForTarget;
          modalEl._sizeGuideOriginalHideForOutsideClick = modalEl.hideForOutsideClickTarget;
        }
        // CRITICAL: Deactivate the focus trap to allow inputs to receive focus
        // The focus trap actively prevents elements outside its boundary from gaining focus
        // This is why clicks work (close button) but inputs don't (need focus for keyboard)
        if (modalEl.focusTrap && typeof modalEl.focusTrap.deactivate === "function") {
          try {
            modalEl.focusTrap.deactivate({
              returnFocus: false,
              // Don't return focus when deactivating
              onDeactivate: function onDeactivate() {} // Prevent the modal from closing
            });
            modalEl._sizeGuideFocusTrapWasActive = true;
          } catch (e) {
            console.warn("Failed to deactivate focus trap:", e);
          }
        }
        // Override allowOutsideClickForTarget to allow clicks on size guide
        modalEl.allowOutsideClickForTarget = function (target) {
          var _modalEl$_sizeGuideOr;
          // Check if the click is within the size guide modal
          if (modalRoot.contains(target)) {
            return true; // Allow the click to pass through
          }
          // Otherwise, use original behavior
          return ((_modalEl$_sizeGuideOr = modalEl._sizeGuideOriginalAllowOutsideClick) === null || _modalEl$_sizeGuideOr === void 0 ? void 0 : _modalEl$_sizeGuideOr.call(modalEl, target)) || false;
        };
        // Override hideForOutsideClickTarget to prevent closing when clicking size guide
        modalEl.hideForOutsideClickTarget = function (target) {
          var _modalEl$_sizeGuideOr2;
          // Don't close if clicking within the size guide
          if (modalRoot.contains(target)) {
            return false;
          }
          // Reactivate the focus trap if we deactivated it
          if (modalEl._sizeGuideFocusTrapWasActive && modalEl.focusTrap) {
            try {
              modalEl.focusTrap.activate();
              delete modalEl._sizeGuideFocusTrapWasActive;
            } catch (e) {
              console.warn("Failed to reactivate focus trap:", e);
            }
          }
          // Otherwise, use original behavior
          return ((_modalEl$_sizeGuideOr2 = modalEl._sizeGuideOriginalHideForOutsideClick) === null || _modalEl$_sizeGuideOr2 === void 0 ? void 0 : _modalEl$_sizeGuideOr2.call(modalEl, target)) || false;
        };
      });
    }
  }, {
    key: "restoreUnderlyingModals",
    value: function restoreUnderlyingModals() {
      // Restore original methods on all patched modals
      var underlyingModals = document.querySelectorAll("x-modal, x-drawer, cart-drawer, quick-buy-modal");
      underlyingModals.forEach(function (modal) {
        var modalEl = modal;
        if (modalEl._sizeGuideOriginalAllowOutsideClick) {
          modalEl.allowOutsideClickForTarget = modalEl._sizeGuideOriginalAllowOutsideClick;
          delete modalEl._sizeGuideOriginalAllowOutsideClick;
        }
        if (modalEl._sizeGuideOriginalHideForOutsideClick) {
          modalEl.hideForOutsideClickTarget = modalEl._sizeGuideOriginalHideForOutsideClick;
          delete modalEl._sizeGuideOriginalHideForOutsideClick;
        }
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var modalRoot = this.getModalRoot();
      if (!modalRoot) return;
      modalRoot.classList.add("tw:hidden!");
      modalRoot.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("tw:overflow-hidden");
      this.isOpen = false;
      document.removeEventListener("keydown", this.handleKeyDown);
      // Restore underlying modals to their original behavior
      this.restoreUnderlyingModals();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/VariantSelection/VariantSelection.ts"
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/VariantSelection/VariantSelection.ts ***!
  \***************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ VariantSelection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Simple handler for variant selection - updates button text from "Choose size" to appropriate state
 */
var VariantSelection = /*#__PURE__*/function (_HTMLElement) {
  function VariantSelection() {
    var _this;
    _classCallCheck(this, VariantSelection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VariantSelection, [].concat(args));
    _defineProperty(_this, "form", null);
    _defineProperty(_this, "abortController", void 0);
    _defineProperty(_this, "hasSizeVariant", false);
    return _this;
  }
  _inherits(VariantSelection, _HTMLElement);
  return _createClass(VariantSelection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.abortController = new AbortController();
      var formId = this.getAttribute("form");
      if (formId) {
        this.form = document.getElementById(formId);
        if (this.form) {
          // Check if product has size variants
          this.hasSizeVariant = this.checkHasSizeVariant();
          // Only clear size selection when button shows "Choose size"
          // This ensures:
          // 1. Initial load with "Choose size": size is NOT pre-selected
          // 2. After user selects (button shows "Add to cart"): size stays selected
          if (this.hasSizeVariant && this.shouldClearSizeSelection()) {
            requestAnimationFrame(function () {
              _this2.clearSizeVariantSelection(formId);
            });
          }
          // Listen for variant changes
          this.form.addEventListener("variant:change", this.onVariantChange.bind(this), {
            signal: this.abortController.signal
          });
          // Setup sticky button click handler
          this.setupStickyButtonHandler();
        }
      }
    }
    /**
     * Clear any selected size variant radio buttons (only for size options)
     */
  }, {
    key: "clearSizeVariantSelection",
    value: function clearSizeVariantSelection(formId) {
      var variantPicker = document.querySelector("variant-picker[form-id=\"".concat(formId, "\"]"));
      if (variantPicker) {
        // Find size option fieldsets
        var sizeLabels = ["size", "taille", "größe", "dimensione", "tamaño", "maat", "størrelse"];
        var fieldsets = variantPicker.querySelectorAll("fieldset.variant-picker__option");
        fieldsets.forEach(function (fieldset) {
          var _legend$textContent;
          var legend = fieldset.querySelector("legend");
          var legendText = (legend === null || legend === void 0 || (_legend$textContent = legend.textContent) === null || _legend$textContent === void 0 ? void 0 : _legend$textContent.toLowerCase().trim()) || "";
          // Only clear size options, not other variants like color
          if (sizeLabels.some(function (sizeLabel) {
            return legendText.includes(sizeLabel);
          })) {
            var radioInputs = fieldset.querySelectorAll('input[type="radio"][data-option-position]');
            radioInputs.forEach(function (input) {
              var inputEl = input;
              // Remove both the checked property and attribute to ensure CSS :checked and [checked] selectors don't match
              inputEl.checked = false;
              inputEl.removeAttribute("checked");
              // The label/visual element is a SIBLING of the input, not a parent
              // In option-value.liquid, the structure is: <input class="sr-only"> followed by <label class="block-swatch">
              var visualElement = input.nextElementSibling;
              if (visualElement) {
                visualElement.classList.remove("is-selected");
                // Also handle nested swatch elements
                var blockSwatch = visualElement.querySelector(".block-swatch");
                if (blockSwatch) {
                  blockSwatch.classList.remove("is-selected");
                }
              }
            });
          }
        });
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.abortController.abort();
    }
    /**
     * Check if the product has a size option/variant
     * Returns false if product only has non-size variants (e.g., only color)
     */
  }, {
    key: "checkHasSizeVariant",
    value: function checkHasSizeVariant() {
      if (!this.form) return false;
      var variantPicker = document.querySelector("variant-picker[form-id=\"".concat(this.form.id, "\"]"));
      if (!variantPicker) return false;
      // Check if any option is labeled as a size option
      var sizeLabels = ["size", "taille", "größe", "dimensione", "tamaño", "maat", "størrelse"].map(function (s) {
        return s.toLowerCase();
      });
      var optionLabels = variantPicker.querySelectorAll(".variant-picker__option-name, legend");
      var _iterator = _createForOfIteratorHelper(optionLabels),
        _step;
      try {
        var _loop = function _loop() {
            var _label$textContent;
            var label = _step.value;
            var labelText = ((_label$textContent = label.textContent) === null || _label$textContent === void 0 ? void 0 : _label$textContent.toLowerCase().trim()) || "";
            if (sizeLabels.some(function (sizeLabel) {
              return labelText.includes(sizeLabel);
            })) {
              return {
                v: true
              };
            }
          },
          _ret;
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(event) {
      var _this3 = this;
      var variant = event.detail.variant;
      if (!this.form) return;
      // Update main button
      var submitButton = this.form.querySelector('button[type="submit"]');
      var buttonContent = submitButton === null || submitButton === void 0 ? void 0 : submitButton.querySelector("button-content");
      if (submitButton && buttonContent) {
        this.updateButtonState(buttonContent, submitButton, variant);
      }
      // Update sticky buttons
      var stickyButtons = document.querySelectorAll(".sticky-add-button");
      stickyButtons.forEach(function (button) {
        var stickyButtonContent = button.querySelector("button-content");
        if (stickyButtonContent) {
          _this3.updateButtonState(stickyButtonContent, button, variant);
        }
      });
    }
  }, {
    key: "updateButtonState",
    value: function updateButtonState(buttonContent, button, variant) {
      var isSticky = button.classList.contains("sticky-add-button");
      var buttonText;
      // Update button text based on variant state
      if (!variant && this.hasSizeVariant) {
        // Product has size variants but none selected - require size selection
        buttonText = "Choose size";
        // Only disable main button, keep sticky clickable for scroll action
        button.disabled = isSticky ? false : true;
      } else if (!variant) {
        // Product has variants but not size, and no variant selected
        // This shouldn't normally happen as Liquid sets selected_or_first_available_variant
        buttonText = "Add to cart";
        button.disabled = false;
      } else if (!variant.available) {
        buttonText = "Sold out";
        button.disabled = true;
      } else {
        // Variant exists and is available
        var isPreorder = this.checkPreorder(variant);
        buttonText = isPreorder ? "Pre-order" : "Add to cart";
        button.disabled = false;
      }
      // Update button text
      buttonContent.textContent = buttonText;
      // Update animation attributes that might be shown on hover
      if (buttonContent.hasAttribute("rotated-text")) {
        buttonContent.setAttribute("rotated-text", buttonText);
      }
      if (buttonContent.hasAttribute("up-text")) {
        buttonContent.setAttribute("up-text", buttonText);
      }
      // Update title and aria-label for hover/accessibility
      button.setAttribute("title", buttonText);
      button.setAttribute("aria-label", buttonText);
    }
  }, {
    key: "setupStickyButtonHandler",
    value: function setupStickyButtonHandler() {
      var _this4 = this;
      var stickyButtons = document.querySelectorAll(".sticky-add-button");
      stickyButtons.forEach(function (button) {
        button.addEventListener("click", _this4.onStickyButtonClick.bind(_this4), {
          signal: _this4.abortController.signal,
          capture: true
        });
      });
    }
  }, {
    key: "onStickyButtonClick",
    value: function onStickyButtonClick(event) {
      var _buttonContent$textCo;
      var button = event.currentTarget;
      var buttonContent = button.querySelector("button-content");
      if ((buttonContent === null || buttonContent === void 0 || (_buttonContent$textCo = buttonContent.textContent) === null || _buttonContent$textCo === void 0 ? void 0 : _buttonContent$textCo.trim()) === "Choose size") {
        event.preventDefault();
        event.stopPropagation();
        var variantPickerOption = document.querySelector(".variant-picker");
        if (variantPickerOption) {
          variantPickerOption.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
          // Add highlight effect to the variant picker
          var variantPicker = document.querySelector("variant-picker");
          if (variantPicker) {
            variantPicker.classList.add("highlight-picker");
            setTimeout(function () {
              variantPicker.classList.remove("highlight-picker");
            }, 2000);
          }
        }
      }
    }
  }, {
    key: "checkPreorder",
    value: function checkPreorder(variant) {
      // Check if variant has preorder metafield and correct inventory policy
      return variant.preorder_info && variant.inventory_quantity <= 0 && variant.inventory_policy === "continue";
    }
    /**
     * Check if we should clear size selection based on button state
     * Only clear when button shows "Choose size" (initial state requiring selection)
     */
  }, {
    key: "shouldClearSizeSelection",
    value: function shouldClearSizeSelection() {
      var _buttonContent$textCo2;
      if (!this.form) return false;
      var submitButton = this.form.querySelector('button[type="submit"]');
      var buttonContent = submitButton === null || submitButton === void 0 ? void 0 : submitButton.querySelector("button-content");
      var buttonText = (buttonContent === null || buttonContent === void 0 || (_buttonContent$textCo2 = buttonContent.textContent) === null || _buttonContent$textCo2 === void 0 ? void 0 : _buttonContent$textCo2.trim().toLowerCase()) || "";
      // Only clear if button shows "Choose size" - this means no size has been selected yet
      return buttonText === "choose size" || buttonText === "vælg størrelse";
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/utils/CookieMethods.ts"
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ },

/***/ "./resources/styles/app.css"
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkstaey_com"] = self["webpackChunkstaey_com"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;